import { reduce } from "et3-type-guards";
import React from "react";
import { useLocation } from "react-router-dom";
import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import ET3PageDiv from "../../../core/et3-page-div";
import Et3PageTitle from "../../../core/et3-page-title/index";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import getUserMessagesStore from "../../../stores/user-store/messages-store";
import UserMessagesForm from "./user-messages-form";
import UserMessagesData from "./user-messages-data";
import Et3Margin from "../../../core/et3-ui/ET3Margin";

const UserMessages = withLiteObserverAndTheme(() => {
  const location = useLocation();
  React.useEffect(() => {
    const search = reduce(() => location.search, "");
    getCoreHistoryStore().setPageName("USER_MESSAGES", "USER_MESSAGES");
    getUserMessagesStore().checkURLSearch(search);
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("USER")}
        subTitle={i18n.get("MONITOR_USER_MESSAGES")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <UserMessagesForm />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <UserMessagesData />
    </ET3PageDiv>
  );
});
export default UserMessages;
